import React from 'react'

const HorizontalDivider = ({ space }) => {
  return <div {...{ style: { height: '100%', width: space } }} />
}

export default HorizontalDivider
